<div class="h-100 d-flex justify-content-between align-items-center">
  <i
    class="cp icon-add"
    *ngIf="currentRow.relatedTestId && !currentRow.isBackupShown && !currentRow.isBackup && !currentRow.hideRelatedTestAction"
    (click)="onClick('backUpShow')"
    [tooltip]="'Show ' + relatedTestName"></i>
  <i
    class="cp icon-arrow-up"
    *ngIf="currentRow.relatedTestId && currentRow.isBackupShown"
    (click)="onClick('backUpHide')"
    [tooltip]="'Hide ' + relatedTestName"></i>
  <i class="cp icon-tests-settings" (click)="onClick('copy')" tooltip="Test case details"></i>
  <i class="cp icon-refresh" (click)="onClick('repeat')" tooltip="Repeat batch"></i>
  <i class="cp icon-more" (click)="onClick('more')" [ngClass]="{ applied: currentRow.commentId }" tooltip="More actions"></i>
</div>
